import React from 'react';
import { bool, func, object } from 'prop-types';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

import ChangeCountFields from './ChangeCountFields';
import OccurrenceCountFields from './OccurrenceCountFields';
import PercentActiveFields from './PercentActiveFields';
import Select from '../../FormFields/Select';
import TotalDurationFields from './TotalDurationFields';

import defaultClasses from './RuleProcessing.module.css';

const NullField = () => null;

const AggregateFields = {
    ChangeCount:         ChangeCountFields,
    OccurenceCount:      OccurrenceCountFields,
    ConsecutiveDuration: OccurrenceCountFields,
    PercentActive:       PercentActiveFields,
    TotalDuration:       TotalDurationFields
};

const RuleProcessing = ({
    disabled,
    errors,
    onBlur,
    onChange,
    onPatch,
    touched,
    values
}) => {
    /**
     * When the Aggregate Type value changes, reset all other aggregate values
     */
    function handleAggregateTypeChange (event) {
        const { name, value } = event.target;
        onPatch({
            ruleAggregateDuration: 0,
            ruleAggregateCount:    0,
            [name]:                value
        });
    }

    const AggregateField =
        AggregateFields[values.ruleAggregateType] || NullField;

    return (
        <FormControl component="fieldset">
            <FormLabel
                classes={{
                    root: defaultClasses.label
                }}
                component="legend"
                focused={false}
            >
                Additional Rule Processing
            </FormLabel>

            <Select
                errors={errors.ruleAggregateType}
                disabled={disabled}
                label="Rule Aggregate"
                onBlur={onBlur}
                onChange={handleAggregateTypeChange}
                name="ruleAggregateType"
                touched={touched.ruleAggregateType}
                value={values.ruleAggregateType}
            >
                <MenuItem value="None">None</MenuItem>
                {process.env.isRuleAggregateChange ? 
                    <MenuItem value="ConsecutiveDuration">Consecutive Duration</MenuItem>
                    : 
                    <MenuItem value="OccurenceCount">Occurrence Count</MenuItem>
                }
                <MenuItem value="ChangeCount">Change Count</MenuItem>
                <MenuItem value="PercentActive">Percent Active</MenuItem>
                {!process.env.isRuleAggregateChange ? 
                    <MenuItem value="TotalDuration">Total Duration</MenuItem>
                    : 
                    null
                }
            </Select>

            <AggregateField
                disabled={disabled}
                errors={errors}
                onBlur={onBlur}
                onChange={onChange}
                touched={touched}
                values={values}
            />
        </FormControl>
    );
};

RuleProcessing.defaultProps = {
    onBlur:   () => {},
    onChange: () => {},
    onPatch:  () => {}
};

RuleProcessing.propTypes = {
    disabled: bool,
    onBlur:   func,
    onChange: func,
    onPatch:  func,
    values:   object
};

export default RuleProcessing;
